export class LogoraWidget extends HTMLElement {
  static #scriptLoaded = false;
  static #shortname = "";

  get shortname(): string {
    return this.getAttribute("shortname") ?? "";
  }

  get type(): string {
    return this.getAttribute("type") ?? "";
  }

  get resourceId(): string {
    return this.getAttribute("resourceid") ?? "";
  }

  connectedCallback() {
    if (this.shortname) {
      LogoraWidget.#shortname = this.shortname;
    }

    if (!this.type || !this.resourceId) return;

    const configName = `logora_${this.resourceId}_${this.type}`;

    const div = document.createElement("div");
    div.className = "logora_embed";
    div.dataset.objectId = configName;
    this.appendChild(div);

    (window as any)[configName] = {
      shortname: LogoraWidget.#shortname,
      resource: {
        name: this.type,
        id: this.resourceId,
      },
    };

    if (!LogoraWidget.#scriptLoaded) {
      LogoraWidget.#scriptLoaded = true;
      queueMicrotask(() => {
        const script = document.createElement("script");
        script.src = "https://cdn.logora.com/embed.js";
        script.async = true;
        document.head.appendChild(script);
      });
    }
  }
}

customElements.get("ws-logora-widget") ??
  customElements.define("ws-logora-widget", LogoraWidget);

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface HTMLElementTagNameMap {
    "ws-logora-widget": LogoraWidget;
  }
}
